import axios from 'axios';
import apiConfig from '../api.config';

export default function getQuickguideImages() {
  const {
    host,
    URIs: { quickguideImages },
  } = apiConfig;

  const uri = `${host}${quickguideImages}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
